import { Wifi, WifiOff, RefreshCw, CloudOff } from "lucide-react";
import { useOffline } from "@/contexts/OfflineContext";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

export function OfflineIndicator() {
  const { isOnline, stats, isSyncing } = useOffline();

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className="flex items-center gap-1.5 cursor-default">
          {isSyncing ? (
            <RefreshCw className="h-4 w-4 text-primary animate-spin" />
          ) : isOnline ? (
            <Wifi className="h-4 w-4 text-emerald-500" />
          ) : (
            <WifiOff className="h-4 w-4 text-destructive" />
          )}
          <span className="hidden sm:inline text-[10px] font-semibold uppercase tracking-wider">
            {isSyncing ? "Syncing" : isOnline ? "Online" : "Offline"}
          </span>
          {stats.pending > 0 && (
            <Badge variant="secondary" className="h-4 min-w-4 px-1 text-[9px] leading-none">
              {stats.pending}
            </Badge>
          )}
          {!isOnline && stats.pending > 0 && (
            <CloudOff className="h-3 w-3 text-muted-foreground" />
          )}
        </div>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="text-xs">
        {isSyncing
          ? "Syncing offline entries to cloud..."
          : isOnline
            ? stats.pending > 0
              ? `Online — ${stats.pending} entries awaiting sync`
              : "Online — All data synced"
            : `Offline — ${stats.pending} entries stored locally`}
      </TooltipContent>
    </Tooltip>
  );
}
